import React from 'react';
import { GlobalToken } from 'antd';

import { YlabelStyled } from './Ylabel.styles';

export const Ylabel = ({ value, token }: { value: string; token: GlobalToken }) => {
  return (
    <YlabelStyled $color={token.colorTextSecondary} $fontSize={token.fontSizeSM}>
      {String(value)}
    </YlabelStyled>
  );
};
